import type {FC} from "react"

import type {GlossaryFragment} from "datasources/datocms"

import {GlossaryButton} from "./GlossaryButton"

interface Props {
  glossary: GlossaryFragment[]
}

// Примечание: Описание терминов хранится в блоке, количество их всегда 1,
// однако DatoCMS всё равно отдаёт этот элемент как массив
export const Glossary: FC<Props> = ({glossary}) => (
  <div className="flex flex-wrap py-5">
    {glossary.map(({id, title, description}) => (
      <GlossaryButton
        key={id}
        title={title as string}
        description={description[0].content!.value}
        className="mb-3 mr-3"
      />
    ))}
  </div>
)
